import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {Routes, RouterModule} from '@angular/router';
import { AppComponent } from './app.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { SubjectsListComponent } from './subjects-list/subjects-list.component';
import { LoadQuizComponent } from './load-quiz/load-quiz.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { EditQuizComponent } from './edit-quiz/edit-quiz.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { EscapeHtmlPipe } from '../shared/pipes/keep-html.pipe';
import { LoginPageComponent } from './login-page/login-page.component';
import { TinymiceEditorComponent } from './tinymice-editor/tinymice-editor.component';
import { AddSubjectComponent } from './add-subject/add-subject.component';
import {PagerServiceService} from '../shared/services/pager-service/pager-service.service';


const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'login', component: LoginPageComponent},
  {path: 'subjects', component: SubjectsListComponent},
  {path: 'add-subject', component: AddSubjectComponent},
  {path: 'quiz/:id', component: LoadQuizComponent},
  {path: 'quiz/edit-quiz/:id', component: EditQuizComponent},
  {path: '**', component: NotFoundComponent}
];

@NgModule({
  declarations: [
    EscapeHtmlPipe,
    AppComponent,
    SideNavComponent,
    SubjectsListComponent,
    LoadQuizComponent,
    NotFoundComponent,
    EditQuizComponent,
    LoginPageComponent,
    TinymiceEditorComponent,
    AddSubjectComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot(routes, {useHash: true})],
  providers: [PagerServiceService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts